var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"question-sticker",class:[ 'positionX-' + _vm.positionX, 'positionY-' + _vm.positionY, 'bleed-' + _vm.bleed ],style:('transform: rotate(' + _vm.rotate + 'deg);'),attrs:{"src":'/question_assets/' + _vm.fileName}})}
var staticRenderFns = []

export { render, staticRenderFns }